import { ResultsCalculator as Results } from './Results/ResultsCalculator'
import { RevenueCalculator as Revenue } from './Revenue/RevenueCalculator'

export default {
  Results,
  Revenue
}
